function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["buttonProps", "children", "className", "closeOnClickAway", "container", "containerOffset", "id", "insidePopout", "labels", "listItemProps", "listItems", "listProps", "loading", "look", "onClose", "openOnHover", "placement", "possiblePlacements", "preventCutoff", "transitionDelay", "transitionDuration", "triggerOffset", "virtualized"],
  _excluded2 = ["ref", "style"],
  _excluded3 = ["look"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useRef, useState, useEffect, useContext } from 'react';
import { useHover, useLayer } from 'react-laag';
import { Transition } from 'react-transition-group';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import { DropdownLooks } from "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import { ListLooks } from "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import { Placements } from "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { useClickOutside } from "../../../../hooks/use-click-outside.js";
import "../../../../utilities/color.js";
import { getContainer } from "../../../../utilities/container.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { mergeRefs } from "../../../../utilities/refs.js";
import { usePrefersReducedMotion } from "../../../../hooks/use-prefers-reduced-motion.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { transitionFadeIn } from "../../../../styles/transitions/fade-in.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import '@brandfolder/utilities';
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import "../../../atoms/button/icon-button/icon-button.js";
import { StandardButton } from "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
import { StandardList } from "../../../internal/list/standard-list/standard-list.js";
import "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import "../../../internal/textfield/textfield-body.js";
import "../../../internal/textfield/textfield-header.js";
import "../../../internal/textfield/textfield-icon.js";
import "../../../internal/textfield/textfield-inner.js";
import "../../../internal/textfield/textfield-wrapper.js";
import { BaseDropdown } from "../base-dropdown/base-dropdown.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var UnstyledDropdown = function UnstyledDropdown(props) {
  var _classnames;
  var buttonProps = props.buttonProps,
    children = props.children,
    className = props.className,
    _props$closeOnClickAw = props.closeOnClickAway,
    closeOnClickAway = _props$closeOnClickAw === void 0 ? true : _props$closeOnClickAw,
    container = props.container,
    _props$containerOffse = props.containerOffset,
    containerOffset = _props$containerOffse === void 0 ? 0 : _props$containerOffse,
    id = props.id,
    insidePopout = props.insidePopout,
    _props$labels = props.labels,
    labels = _props$labels === void 0 ? {} : _props$labels,
    listItemProps = props.listItemProps,
    listItems = props.listItems,
    listProps = props.listProps,
    loading = props.loading,
    look = props.look,
    onClose = props.onClose,
    _props$openOnHover = props.openOnHover,
    openOnHover = _props$openOnHover === void 0 ? false : _props$openOnHover,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? Placements.BottomStart : _props$placement,
    _props$possiblePlacem = props.possiblePlacements,
    possiblePlacements = _props$possiblePlacem === void 0 ? [Placements.BottomStart, Placements.BottomEnd, Placements.TopStart, Placements.TopEnd] : _props$possiblePlacem,
    _props$preventCutoff = props.preventCutoff,
    preventCutoff = _props$preventCutoff === void 0 ? true : _props$preventCutoff,
    _props$transitionDela = props.transitionDelay,
    transitionDelay = _props$transitionDela === void 0 ? 0 : _props$transitionDela,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 200 : _props$transitionDura,
    _props$triggerOffset = props.triggerOffset,
    triggerOffset = _props$triggerOffset === void 0 ? 5 : _props$triggerOffset,
    _props$virtualized = props.virtualized,
    virtualized = _props$virtualized === void 0 ? false : _props$virtualized,
    otherProps = _objectWithoutProperties(props, _excluded);
  var loaderLabel = labels.loaderLabel;
  var listId = "".concat(id, "-list");
  var wrapperRef = useRef(null);
  var _useClickOutside = useClickOutside({
      ref: wrapperRef
    }),
    clickedOutside = _useClickOutside.clickedOutside;
  var nodeRef = useRef(null);
  var prefersReducedMotion = usePrefersReducedMotion();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useHover = useHover(),
    _useHover2 = _slicedToArray(_useHover, 2),
    isOver = _useHover2[0],
    hoverProps = _useHover2[1];
  var hasHovered = openOnHover && isOver;
  var isOpen = hasHovered || open;
  useEffect(function () {
    if (insidePopout && clickedOutside && closeOnClickAway) {
      handleToggle(false);
    }
  }, [clickedOutside]); // eslint-disable-line react-hooks/exhaustive-deps
  var getButtonLook = function getButtonLook() {
    switch (look) {
      case DropdownLooks.Primary:
        {
          return ButtonLooks.Primary;
        }
      default:
        {
          return ButtonLooks.Default;
        }
    }
  };
  var getListLook = function getListLook() {
    switch (look) {
      case DropdownLooks.Primary:
        {
          // TODO: Add more looks
          return ListLooks.Default;
        }
      default:
        {
          return ListLooks.Default;
        }
    }
  };
  var handleOnClose = function handleOnClose() {
    if (onClose) onClose();
  };
  var handleToggle = function handleToggle(toggle) {
    if (!toggle) {
      handleOnClose();
    }
    setOpen(toggle);
  };
  var onOutsideClick = function onOutsideClick() {
    if (closeOnClickAway) handleToggle(false);
  };
  var _useLayer = useLayer({
      auto: preventCutoff,
      container: container || getContainer(id),
      containerOffset: containerOffset,
      isOpen: isOpen,
      placement: placement,
      possiblePlacements: possiblePlacements,
      onOutsideClick: onOutsideClick,
      overflowContainer: true,
      snap: true,
      triggerOffset: triggerOffset
    }),
    layerProps = _useLayer.layerProps,
    renderLayer = _useLayer.renderLayer,
    triggerProps = _useLayer.triggerProps;
  var ref = layerProps.ref,
    layerPropsStyle = layerProps.style,
    otherLayerProps = _objectWithoutProperties(layerProps, _excluded2);
  var timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
  return /*#__PURE__*/React.createElement(BaseDropdown, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-dropdown__standard': true,
      'bf-dropdown__standard--expanded': isOpen
    }, _defineProperty(_classnames, "bf-dropdown__standard--placement-".concat(placement), placement), _defineProperty(_classnames, 'bf-dropdown__standard--virtualized', virtualized), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    id: id,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(StandardButton, _extends({}, buttonProps, triggerProps, hoverProps, {
    "aria-controls": listId,
    "aria-expanded": isOpen,
    className: classnames(_defineProperty({
      'bf-dropdown__button': true
    }, "".concat(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className), !!(buttonProps !== null && buttonProps !== void 0 && buttonProps.className))),
    endIcon: isOpen ? FontIcons.CaretUp : FontIcons.CaretDown,
    look: getButtonLook(),
    onClick: function onClick(e) {
      handleToggle(!isOpen);
      if (buttonProps !== null && buttonProps !== void 0 && buttonProps.onClick) {
        buttonProps.onClick(e);
      }
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        handleToggle(!isOpen);
      }
      if (buttonProps !== null && buttonProps !== void 0 && buttonProps.onKeyUp) {
        buttonProps.onKeyUp(e);
      }
    }
  }), children), renderLayer( /*#__PURE__*/React.createElement(Transition, {
    appear: isOpen,
    in: isOpen,
    mountOnEnter: true,
    timeout: timeout,
    unmountOnExit: true
  }, function (transitionStatus) {
    return /*#__PURE__*/React.createElement(StandardList, _extends({}, listProps, hoverProps, otherLayerProps, {
      className: classnames(_defineProperty({
        'bf-dropdown__list': true
      }, "".concat(listProps === null || listProps === void 0 ? void 0 : listProps.className), !!(listProps !== null && listProps !== void 0 && listProps.className))),
      id: listId,
      labels: {
        loaderLabel: loaderLabel
      },
      listItemProps: listItemProps,
      listItems: listItems,
      loading: loading,
      look: getListLook(),
      ref: mergeRefs([nodeRef, ref]),
      style: _objectSpread(_objectSpread(_objectSpread({}, listProps === null || listProps === void 0 ? void 0 : listProps.style), layerPropsStyle), !prefersReducedMotion && transitionDuration > 0 && transitionFadeIn({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      })),
      virtualized: virtualized
    }));
  })));
};
var StyledDropdown = styled(UnstyledDropdown)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .bf-button__standard {\n    .bf-icon {\n      font-size: 12px;\n    }\n  }\n\n  .bf-list__standard {\n    display: none;\n  }\n\n  &.bf-dropdown__standard--expanded {\n    .bf-list__standard {\n      display: block;\n    }\n  }\n"])));
/**
 * A dropdown component for showing content within `role="list"` and `role="listitem"`.
 * Suitable content includes links.
 *
 * Required props include `children`, `id`, and `listItems`. It is recommended to set a
 * `width` via CSS class or `style` prop on the `.bf-dropdown__list`, otherwise the `<ul>`
 * width will be as wide as the widest `<li>` elements' content.
 *
 * For dropdowns, `closeOnClickAway` defaults to `true`. Dropdown positioning defaults to
 * `Placements.BottomStart` (left aligned). To right align, set `placement={Placements.BottomEnd}`.
 *
 * Set `loading` and `labels.loaderLabel` to show a `<CircleLoader>` within the dropdown.
 *
 * For list items greater than `10`, set `virtualized` to `true` to window content for
 * better performance.
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/list_role
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listitem_role
 *
 * https://www.w3.org/WAI/ARIA/apg/example-index/disclosure/disclosure-navigation
 *
 * @param props StandardDropdownProps
 * @returns FunctionComponent<StandardDropdownProps>
 */
var StandardDropdown = function StandardDropdown(props) {
  var _props$look = props.look,
    look = _props$look === void 0 ? DropdownLooks.Default : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded3);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(StyledDropdown, _extends({}, otherProps, {
    look: look
  })));
};
export { StandardDropdown };